import { useEffect, useState } from 'react';
import { testPeriodsAPI } from '../services/api';
import type { TestPeriod } from '../types';

// Fetch the configured current test/survey period once (module-cached), so pages
// can default their date pickers to it. Returns null until loaded / if none set.
let cache: Promise<TestPeriod | null> | null = null;

export function useCurrentTestPeriod(): TestPeriod | null {
  const [period, setPeriod] = useState<TestPeriod | null>(null);
  useEffect(() => {
    if (!cache) cache = testPeriodsAPI.getCurrent().catch(() => null);
    let alive = true;
    cache.then(p => { if (alive) setPeriod(p); });
    return () => { alive = false; };
  }, []);
  return period;
}
